import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { TweenMax } from 'gsap';

import * as actions from '../store/actions/churgerBuilderActions';

export default function Home() {
	let firstPic = useRef();
	let secondPic = useRef();

	useEffect(() => {
		TweenMax.from(firstPic, 2.0, {
			opacity: 0,
			y: 1080,
			ease: 'bounce',
		});
	});
	useEffect(() => {
		TweenMax.from(secondPic, 2.0, {
			opacity: 0,
			y: -1080,
			ease: 'bounce',
			delay: 0.8,
		});
	});

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(actions.setPage('notOrder'));
	});

	return (
		<div className="Home">
			<h1 id="headline">i'm love the it</h1>
			<div ref={(el) => (firstPic = el)} id="firstPic" />
			<div id="firstContent">
				<h2>Build yurself a beeschurger!*</h2>
				<p>
					Why would we pay someone minimum wage, when you can do it yorslef for
					free?
				</p>
				<p className="legal">*Ingredients may cause stroke.</p>
			</div>
			<NavLink className="btn" id="firstLink" to="/order">
				Order Now
			</NavLink>
			<div id="blank1" />

			<div id="secondContent">
				<h2>Would yuo like to speank to the manager?*</h2>
				<p>We're not happy till your not happy.</p>
				<p className="legal">*Not happiness guaranteed.</p>
			</div>
			<div id="blank2" />

			<NavLink to="/halp" className="btn" id="secondLink">
				Get halp
			</NavLink>

			<div ref={(el) => (secondPic = el)} id="secondPic" />
		</div>
	);
}
